import { useState } from 'react'

export const FOOD_PAYMENT_KEY = '3192635819'

export default function FoodPaymentKey() {
  const [copied, setCopied] = useState(false)

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(FOOD_PAYMENT_KEY)
      setCopied(true)
    } catch {
      setCopied(false)
    }
  }

  return (
    <div className="rounded-2xl border border-[#64ba30]/30 bg-[#64ba30]/5 px-4 py-4 text-left mb-4">
      <p className="text-xs font-semibold uppercase tracking-wide text-[#166534] mb-1">Pago por llave</p>
      <p className="text-2xl font-bold text-[#111827] tracking-wide">{FOOD_PAYMENT_KEY}</p>
      <p className="text-xs text-gray-600 mt-1 mb-3">
        Transfiere a esta llave. Un administrador confirma el pago y activa tu plan.
      </p>
      <button
        type="button"
        onClick={copy}
        className="text-sm font-semibold text-[#166534] underline"
      >
        {copied ? 'Llave copiada' : 'Copiar llave'}
      </button>
    </div>
  )
}
